import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import Button from "../../../components/common/Button";
import Form from "../../../components/common/Form";
import Input from "../../../components/common/Input";
import Logo from "../../../components/logo/Logo";
import SocialLogin from "../../../components/socialLogin/SocialLogin";
import { SET_LOGIN_USER_SUCCESS, SET_OTP } from "../../../store/actions/loginActions";
import { validatePhoneNumber } from "../../../utils";
import { OnLogin, OnOTPVerification, OnSocialLogin } from "../login/queries";
import "./index.scss";
import Divider from "../../../components/common/Divider";
import disable_phone from "../../../svg/disable-phone.svg";
import active_phone from "../../../svg/active-phone.svg";
import FormModal from "../../../components/Modal/formModal";
import VerifyOtp from "../verifyotp";
import LeftBase from "../../../components/common/LeftBase";
import Checkbox from "../../../components/common/Checkbox";
import { OnResendOtp } from "../verifyEmail/queries";

function MobileLogin() {
  const [mobileNumber, setMobileNumber] = useState("");
  const [openMobileVerification, setOpenMobileVerification] = useState(false)
  const [errorMsg, setErrorMsg] = useState('')
  const [otp, setOtp] = useState()
  const [error, setError] = useState({ apiError: '' })
  const [disabled, setDisabled] = useState(true);
  const [checkboxes, setCheckboxes] = useState({
    mobileInfoChecked: false,
  });

  const dispatch = useDispatch()
  const navigate = useNavigate()

  // const otpState = useSelector((state) => state?.LoginReducer.otp);
  // useEffect(() => {
  //   setOtp(otpState);
  //   // eslint-disable-next-line
  // }, [otpState]);

  useEffect(() => {
    setDisabled(mobileNumber?.length !== 10)
  }, [mobileNumber]);
  const sucessHandler = (otp) => {
    dispatch({
      type: SET_OTP,
      payload: otp?.data?.otp,
    });


    setOpenMobileVerification(true)
    return null;
  };
  const sucessHandlerMObileVerification = (auth) => {
    localStorage.setItem("vendorToken", auth.data?.token);
    dispatch({
      type: SET_LOGIN_USER_SUCCESS,
      payload: auth?.data,
    });
    setErrorMsg('')
    setOpenMobileVerification(false)
    navigate('/')
    return null;
  };

  const handleSubmitOtpVerification = async (e) => {
    e.preventDefault();
    mobileLogin({ otp });
  };
  const { mutate: mobileLogin } = OnOTPVerification(sucessHandlerMObileVerification, setErrorMsg);

  const socialSucessHandler = (success) => {
    localStorage.setItem("vendorToken", success.data?.token);
    dispatch({
      type: SET_LOGIN_USER_SUCCESS,
      payload: success?.data,
    });

    navigate("/dashboard");
    return null;
  };

  const { mutate: login } = OnLogin(sucessHandler, error, setError);
  const { mutate: socialLogin } = OnSocialLogin(socialSucessHandler, error, setError);

  const handleSocialLogin = (result) => {
    const data = result?.user;
    const apiBody = {
      fullName: data?.displayName,
      email: (result?.providerId === "twitter.com") ? result?.['_tokenResponse']?.email : data?.email,
      rawId: data?.uid,
      isSocialLogin: true,
    };
    socialLogin(apiBody);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    login({ 'phoneNumber': mobileNumber });
  };
  const handleModalClose = () => {
    setOpenMobileVerification(false)
    setErrorMsg('')
    setOtp()
  }

  const resendOtpSucess = (sucess) => {
    setErrorMsg("");
    if (sucess?.data?.otpformobileverification) {
      setOtp("");
    }
  };

  const handleRensedOtp = (e, type) => {
    e.preventDefault();
    if (type === "email") {
      let param = {
        email: email,
      };
      resedOtp(param);
    } else {
      let param = {
        phoneNumber: mobileNumber,
      };
      resedOtp(param);
    }
  };

  const { mutate: resedOtp } = OnResendOtp(resendOtpSucess, setErrorMsg);

  const handleClickCheckbox = (e, type) => {
    const { name, checked } = e.target;
    return setCheckboxes({ ...checkboxes, [name]: checked });
  };
  return (
    <div className="container-flex mobilelogin-page">
      <div className="row h-100">
        <div className="col-lg-4 col-xl-4 d-none d-lg-block left-base position-relative left-base">
          <LeftBase />
        </div>
        <div className="col-lg-8 col-xl-8 col-md-12 col-sm-12 m-auto">
          <p className="text-end py-2 top_link">
            Not a member?
            <Link to="/registration" className="ms-1 link">
              Register Now
            </Link>
          </p>
          <div className="">
            <div className="frame w-75 m-auto">
              <Logo />
              <h4 className="mt-40">LOGIN</h4>
              <p className="sub_title">
                Add your mobile number to login
              </p>
              <Form onSubmit={handleSubmit}>
                <div className="position-relative">
                  <span
                    className={mobileNumber ? "tel-active" : "tel-disable"}
                  >+91 <span className="ms-6">|</span></span>
                  <Input
                    type="tel"
                    name="mobileNumber"
                    className={
                      mobileNumber
                        ? "form-control active-input with_icon tel-pd"
                        : "form-control grey-input with_icon tel-pd"
                    }
                    preIconClass={mobileNumber ? active_phone : disable_phone}
                    handleChange={(e) => setMobileNumber(validatePhoneNumber(e.target.value))}
                    value={mobileNumber}
                    label='Mobile Number'
                    placeholder='xxxxxxxxxx'
                    labelClass={mobileNumber ? "" : "hidden"}
                  />
                </div>
                <div className="label-error">{error?.apiError}</div>
                <div className="py-3">
                  <Button type="submit" title="CONTINUE" disabled={disabled} />
                </div>
              </Form>
              <div className="my-4">
                <Divider />
              </div>
              <p> <Link to="/" className="linkFont">Continue With Email Login</Link></p>
              <p>You can also login with</p>
              <SocialLogin handleSocialLogin={handleSocialLogin} />
              <div className="col-pd mb-20">
                <label className="info-condition styledCheck position-relative">
                  <Checkbox className="form-check-input" checked={checkboxes.mobileInfoChecked}
                    name="mobileInfoChecked"
                    onRadioChange={handleClickCheckbox} /><span className="link">I'd like to get information on new projects and marketing activities</span></label>
              </div>
              <small className="footer_note">
                Do not forget to add us to your <span className="f-600">Safe Senders List</span><br />We will NEVER post anything without your permission. Isn't this cool?
              </small>
            </div>
          </div>
        </div>

        <FormModal show={openMobileVerification} handleClose={() => handleModalClose()} informationText="Almost there! Just add the OTP received on your mobile no. and let's get going." modalHeading='Verify OTP'>
          <VerifyOtp errorMsg={errorMsg} otp={otp} setOtp={setOtp} handleRensedOtp={handleRensedOtp} handleSubmit={handleSubmitOtpVerification} />
        </FormModal>
      </div>
    </div>
  );
}

export default MobileLogin;
